import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-okta-integration',
  templateUrl: './okta-integration.component.html',
  styleUrls: ['./okta-integration.component.css'],
})
export class OktaIntegrationComponent {}
